import { useState } from "react";
import { IMAGES } from "@/lib/brand";

const CATEGORIES = [
  { key: "all",       label: "All" },
  { key: "rooms",     label: "Rooms" },
  { key: "nature",    label: "Nature" },
  { key: "kedarnath", label: "Kedarnath" },
  { key: "wedding",   label: "Weddings" },
  { key: "food",      label: "Cuisine" },
];

const PHOTOS = [
  { src: IMAGES.roomLuxury, cat: "rooms" },
  { src: IMAGES.roomBed, cat: "rooms" },
  { src: IMAGES.cottage, cat: "rooms" },
  { src: IMAGES.himalayas, cat: "nature" },
  { src: IMAGES.river, cat: "nature" },
  { src: IMAGES.drone, cat: "nature" },
  { src: IMAGES.heroKedarnath, cat: "kedarnath" },
  { src: IMAGES.bell, cat: "kedarnath" },
  { src: IMAGES.temple, cat: "kedarnath" },
  { src: IMAGES.prayer, cat: "kedarnath" },
  { src: IMAGES.mandap, cat: "wedding" },
  { src: IMAGES.weddingCouple, cat: "wedding" },
  { src: IMAGES.food, cat: "food" },
  { src: IMAGES.gallery1, cat: "nature" },
  { src: IMAGES.gallery2, cat: "rooms" },
  { src: IMAGES.gallery3, cat: "nature" },
  { src: IMAGES.gallery4, cat: "kedarnath" },
];

export default function Gallery() {
  const [filter, setFilter] = useState("all");
  const list = filter === "all" ? PHOTOS : PHOTOS.filter(p => p.cat === filter);

  return (
    <div data-testid="page-gallery">
      <section className="section-pad pb-12">
        <div className="max-w-[1500px] mx-auto px-6 md:px-12">
          <div className="overline">Portfolio</div>
          <h1 className="h-display text-[44px] sm:text-[56px] md:text-[72px] lg:text-[88px] font-light mt-6 max-w-4xl tracking-[-0.025em] leading-[1.02]">
            The Himalayas, <span className="italic text-gold">in frames</span>.
          </h1>

          <div className="flex flex-wrap gap-6 mt-16 border-t border-kc pt-8">
            {CATEGORIES.map(c => (
              <button
                key={c.key} onClick={() => setFilter(c.key)}
                className={`text-[11px] uppercase tracking-[0.28em] transition-colors ${
                  filter === c.key ? "text-gold" : "text-ink hover:text-gold"
                }`}
                data-testid={`gallery-filter-${c.key}`}
              >
                {c.label} {filter === c.key && <span className="ml-2 text-gold">·</span>}
              </button>
            ))}
          </div>
        </div>
      </section>

      <section className="max-w-[1500px] mx-auto px-6 md:px-12 pb-24">
        <div className="columns-1 sm:columns-2 md:columns-3 gap-4 [column-fill:_balance]">
          {list.map((p, i) => (
            <div key={i} className="mb-4 img-zoom break-inside-avoid" data-testid={`gallery-photo-${i}`}>
              <img src={p.src} alt={`${p.cat} moment`} loading="lazy" className="w-full h-auto object-cover" />
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
